import { createSlice } from '@reduxjs/toolkit';

const signInErrorMessageSlice = createSlice({
    name: 'signInErrorMessage',
    initialState: null,
    reducers: {
        setSignInErrorMessage: (state, action) => action.payload,
    },
});

export const { setSignInErrorMessage } = signInErrorMessageSlice.actions;

export default signInErrorMessageSlice.reducer;
